module.exports = __webpack_public_path__ + "static/media/wireframe2@4x.6565d75b.png";